import produce from "immer";
import { SET_BRAND_REGISTRATION } from "redux/constants/TwilioBrandRegostration";

export const initialState = {
  brand_data: null,
};

const brandRegistrationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, payload } = action;
    switch (type) {
      case SET_BRAND_REGISTRATION:
        draft.brand_data = payload;
        break;
      default:
        return state;
    }
  });

export default brandRegistrationReducer;
